import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const FreshnessContext = createContext(null);

// Global "Data as of" trust cue — fetched once for the whole app and refreshed
// every 5 minutes (and after uploads via refresh()).
export const FreshnessProvider = ({ children }) => {
  const [freshness, setFreshness] = useState(null);

  const refresh = useCallback(() => {
    api
      .get("/data-freshness")
      .then((r) => setFreshness(r.data))
      .catch((e) => console.error("Data freshness fetch failed:", e));
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, [refresh]);

  return (
    <FreshnessContext.Provider value={{ freshness, refresh }}>
      {children}
    </FreshnessContext.Provider>
  );
};

export const useFreshness = () =>
  useContext(FreshnessContext) || { freshness: null, refresh: () => {} };
